<div class="main" [ngClass]="{ 'is-portrait': isPortraitDevice }">
    <div class="container" [ngClass]="{ 'is-portrait': isPortraitDevice }">
        <div class="headlines">
            <h1 *ngIf="!isPortraitDevice" class="headline-m">
                {{ workingSituationTitle | translate }}
            </h1>

            <p class="subtitle-m">
                {{ workingSituationSubtitle | translate }}
            </p>
        </div>

        <form class="form" [formGroup]="formGroup">
            <!-- workStatus -->
            <div class="form-row">
                <div class="form-field">
                    <p-selectButton
                        id="workStatus"
                        formControlName="workStatus"
                        class="p-selectbutton"
                        [options]="workStatusOptions"
                        optionLabel="label"
                        optionValue="code"
                        (onOptionClick)="onChangeWorkStatus($event)"
                    ></p-selectButton>

                    <!--
                    <p-selectButton
                        id="workStatus"
                        formControlName="workStatus"
                        class="p-selectbutton"
                        [options]="workStatusOptions"
                        (onOptionClick)="onChangeWorkStatus($event)"
                    >
                        <ng-template let-status pTemplate>
                            <span>{{ status.label | translate | titlecase }}</span>
                        </ng-template>
                    </p-selectButton>
 -->
                </div>
            </div>

            <!----------------->
            <!---- WORKING ---->
            <!----------------->

            <!-- sector -->
            <div *ngIf="workingSelected && showForm" class="form-row">
                <div class="form-field">
                    <p-dropdown
                        class="p-dropdown"
                        placeholder="{{ sectorText | translate }}"
                        formControlName="sector"
                        id="sector"
                        class=""
                        [options]="professionalSectors"
                        optionLabel="label"
                        inputId="float-label"
                        (onChange)="onChangeSector($event)"
                    >
                        <ng-template pTemplate="selectedItem">
                            <div class="flex align-items-center gap-2" *ngIf="selectedProfessionalSector">
                                <span class="float-label-dropdown">{{ sectorText | translate }}</span>

                                <div class="data-field-value-dropdown-item-selected">
                                    {{ selectedProfessionalSector.description | titlecase }}
                                </div>
                            </div>
                        </ng-template>
                        <ng-template let-professionalSector pTemplate="item">
                            <div class="flex align-items-center gap-2">
                                <div class="selected-item-dropdown data-field-value-dropdown">
                                    {{ professionalSector.description | titlecase }}
                                    <i *ngIf="professionalSector == selectedProfessionalSector" class="ri-check-line"></i>
                                </div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
            </div>

            <!-- BRANCH -->
            <div *ngIf="workingSelected && showForm" class="form-row">
                <div class="form-field">
                    <p-dropdown
                        class="p-dropdown"
                        placeholder="{{ branchText | translate }}"
                        formControlName="branch"
                        id="branch"
                        class=""
                        [options]="branches"
                        [filter]="true"
                        filterBy="fieldDescription"
                        optionLabel="label"
                        inputId="float-label"
                        (onChange)="onChangeBranch($event)"
                        [virtualScroll]="true"
                        [virtualScrollItemSize]="38"
                    >
                        <ng-template pTemplate="selectedItem">
                            <div class="flex align-items-center gap-2" *ngIf="selectedBranch">
                                <span class="float-label-dropdown">{{ branchText | translate }}</span>

                                <div class="data-field-value-dropdown-item-selected">{{ selectedBranch.fieldDescription | titlecase }}</div>
                            </div>
                        </ng-template>
                        <ng-template let-branch pTemplate="item">
                            <div class="flex align-items-center gap-2">
                                <div class="selected-item-dropdown data-field-value-dropdown">
                                    {{ branch.fieldDescription | titlecase }}
                                    <i *ngIf="branch == selectedBranch" class="ri-check-line"></i>
                                </div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
            </div>
            <!-- PROFESION -->
            <div *ngIf="workingSelected && showForm" class="form-row">
                <div class="form-field">
                    <p-dropdown
                        class="p-dropdown"
                        placeholder="{{ professionText | translate }}"
                        formControlName="profession"
                        id="profession"
                        class=""
                        [options]="professionsFiltered"
                        [filter]="true"
                        filterBy="professionDescription"
                        optionLabel="label"
                        inputId="float-label"
                        (onChange)="onChangeProfession($event)"
                        [virtualScroll]="true"
                        [virtualScrollItemSize]="38"
                    >
                        <ng-template pTemplate="selectedItem">
                            <div class="flex align-items-center gap-2" *ngIf="selectedProfession">
                                <span class="float-label-dropdown">{{ professionText | translate }}</span>

                                <div class="data-field-value-dropdown-item-selected">
                                    {{ selectedProfession.professionDescription | titlecase }}
                                </div>
                            </div>
                        </ng-template>
                        <ng-template let-profession pTemplate="item">
                            <div class="flex align-items-center gap-2">
                                <div class="selected-item-dropdown data-field-value-dropdown">
                                    {{ profession.professionDescription | titlecase }}
                                    <i *ngIf="profession == selectedProfession" class="ri-check-line"></i>
                                </div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
            </div>
            <!-- COMPANY -->
            <div *ngIf="workingSelected && showForm" class="form-row">
                <div class="form-input-row">
                    <div class="form-input">
                        <input
                            type="text"
                            class="input"
                            formControlName="company"
                            id="company"
                            name="company"
                            placeholder=""
                            (keyup)="onChangeCompany($event)"
                        />
                        <label class="input-label" for="company">{{ companyName | translate }}</label>

                        <div *ngIf="this.formGroup.controls.company.valid" class="input-icon">
                            <i class="ri-check-line class-icono"></i>
                        </div>
                    </div>

                    <!--

                        <div class="form-floating form-floating-group flex-grow-1">
                            <input
                                type="text"
                                class="textarea form-control"
                                formControlName="company"
                                id="company"
                                name="company"
                                placeholder=""
                                (keyup)="onChangeCompany($event)"
                            />
                            <label for="company">{{ companyName | translate }}</label>
                        </div>
                         -->
                </div>
            </div>

            <!--------------------->
            <!---- NOT WORKING ---->
            <!--------------------->

            <!-- notWorkingSituation -->
            <div *ngIf="!workingSelected && showForm" class="form-row">
                <div class="form-field">
                    <p-dropdown
                        class="p-dropdown"
                        placeholder="{{ situationText | translate }}"
                        formControlName="notWorkingSituation"
                        id="notWorkingSituation"
                        [filter]="true"
                        filterBy="professionDescription"
                        class=""
                        [options]="notWorkingSituationOptions"
                        optionLabel="label"
                        inputId="float-label"
                        (onChange)="onChangeSituation($event)"
                    >
                        <ng-template pTemplate="selectedItem">
                            <div class="flex align-items-center gap-2" *ngIf="selectedWorkStatus">
                                <span class="float-label-dropdown">{{ situationText | translate }}</span>
                                <div class="data-field-value-dropdown-item-selected">{{ selectedSituation?.professionDescription }}</div>
                            </div>
                        </ng-template>
                        <ng-template let-situation pTemplate="item">
                            <div class="flex align-items-center gap-2">
                                <div class="selected-item-dropdown data-field-value-dropdown">
                                    {{ situation.professionDescription | titlecase }}
                                    <i *ngIf="situation == selectedSituation" class="ri-check-line"></i>
                                </div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
            </div>

            <!-- revenue -->
            <div *ngIf="!workingSelected && showForm" class="form-row">
                <div class="form-input-row">
                    <div class="form-input">
                        <input
                            type="text"
                            class="input"
                            formControlName="revenue"
                            id="revenue"
                            name="revenue"
                            placeholder=""
                            (keyup)="onChangeRevenue($event)"
                        />
                        <label class="input-label" for="revenue">{{ monthlyNetIncomeLabel | translate }}</label>

                        <div *ngIf="this.formGroup.controls.revenue.valid" class="input-icon">
                            <i class="ri-check-line class-icono"></i>
                        </div>
                    </div>
                </div>
            </div>

            <!-- lastJob -->
            <div *ngIf="!workingSelected && showForm" class="form-row">
                <div class="form-input-row">
                    <div class="form-input">
                        <input
                            type="text"
                            class="input"
                            formControlName="lastJob"
                            id="lastJob"
                            name="lastJob"
                            placeholder=""
                            (keyup)="onChangeLastJob($event)"
                        />
                        <label class="input-label" for="lastJob">{{ lastJobText | translate }}</label>

                        <div *ngIf="this.formGroup.controls.lastJob.valid" class="input-icon">
                            <i class="ri-check-line class-icono"></i>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <div class="actions">
            <button
                *ngIf="!isPortraitDevice"
                pripple=""
                class="button-secondary button-next"
                type="button"
                [disabled]="backButtonDisabled"
                (click)="onClicButtonBack()"
            >
                <span class="ri-arrow-left-line p-button-icon p-button-icon-left ng-star-inserted"></span>
                <span class="p-button-label-right">{{ backButton | translate }}</span>
            </button>

            <button
                pripple=""
                class="button-primary button-next"
                type="button"
                [disabled]="continueButtonDisabled"
                (click)="onClicButtonContinue()"
                [ngClass]="{ 'is-portrait': isPortraitDevice }"
            >
                <span class="p-button-label-left">{{ continueButton | translate }}</span>
                <span class="ri-arrow-right-line p-button-icon p-button-icon-right ng-star-inserted"></span>
            </button>
        </div>
    </div>

    <div *ngIf="isPortraitDevice">
        <app-footer></app-footer>
    </div>

    <div class="chat-layer">
        <app-chat-layer></app-chat-layer>
    </div>
</div>
